// extracted by mini-css-extract-plugin
export default {"row":"accountPage_row__GeUdp","settings_btn":"accountPage_settings_btn__Wpmum","section":"accountPage_section__pnR3T","section_wrapper":"accountPage_section_wrapper__3royZ"};